import AppDBStorage from '@Services/AppDBStorage';

class StructureContainersStorage extends AppDBStorage {
  constructor() {
    super('structureContainers_');
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultValue = () => ({});
}

export default new StructureContainersStorage();
